export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line' },
];

export const comics = [
  {
    id: 1,
    title: '某天成为公主',
    slug: 'one-day-became-princess',
    category: 'romance',
    author: 'Spoon',
    description: '某天醒来发现自己变成了童话故事里的公主，还是一个注定要死的配角。为了改变命运，她开始接近冷酷的父皇克劳德，试图用可爱和温暖融化他那颗冰冷的心。一部融合了奇幻、亲情与爱情元素的精彩韩漫。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20featuring%20a%20princess%20with%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20an%20elegant%20pink%20gown%2C%20soft%20romantic%20atmosphere%2C%20delicate%20flower%20petals%20floating%2C%20watercolor%20style%2C%20clean%20simple%20background%20with%20warm%20pastel%20tones&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    rating: 4.9,
    views: 1250000,
    chapters: 125,
    status: 'completed',
    tags: ['穿越', '皇室', '治愈'],
    updateTime: '2026-08-03',
    featured: true,
    hotRank: 1,
  },
  {
    id: 2,
    title: '我独自升级',
    slug: 'solo-leveling',
    category: 'action',
    author: 'Chugong',
    description: '在连接异次元与现实世界的"门"出现后，觉醒者们开始猎杀地下城中的魔物。被称为人类最弱兵器的成振宇，在一次双重地下城任务中濒死，却意外获得了"系统"的力量，成为唯一能够无限升级的玩家。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20featuring%20a%20black-haired%20hunter%20with%20glowing%20purple%20eyes%20surrounded%20by%20shadow%20soldiers%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20clean%20simple%20dark%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    rating: 4.9,
    views: 3200000,
    chapters: 179,
    status: 'completed',
    tags: ['系统', '升级', '热血', '暗影'],
    updateTime: '2026-08-04',
    featured: true,
    hotRank: 2,
  },
  {
    id: 3,
    title: '她的私生活',
    slug: 'her-private-life',
    category: 'romance',
    author: '金海媛',
    description: '美术馆策展人成德美过着双重生活——白天是专业的职场女性，晚上则是追星站姐。当新馆长莱恩·金发现她的秘密后，两人展开了一段甜蜜又爆笑的浪漫故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20romance%20Korean%20manhwa%20cover%20featuring%20a%20stylish%20woman%20with%20long%20brown%20hair%20in%20office%20attire%2C%20holding%20a%20camera%2C%20warm%20and%20cozy%20atmosphere%2C%20clean%20simple%20background%20with%20soft%20lighting&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    rating: 4.7,
    views: 890000,
    chapters: 87,
    status: 'ongoing',
    tags: ['职场', '追星', '甜蜜'],
    updateTime: '2026-08-04',
    featured: false,
    hotRank: 5,
  },
  {
    id: 4,
    title: '全知读者视角',
    slug: 'omniscient-reader-viewpoint',
    category: 'fantasy',
    author: 'sing N song',
    description: '金独子是一个普通的上班族，唯一的爱好就是追一部连载了十多年的网文。当这部小说完结那天，世界突然变成了小说中的末日场景。作为唯一读完结局的人，他开始了拯救世界的旅程。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20apocalyptic%20Korean%20manhwa%20cover%20featuring%20a%20man%20in%20a%20white%20coat%20holding%20a%20glowing%20book%2C%20surrounded%20by%20constellations%20in%20the%20sky%2C%20epic%20scale%2C%20clean%20simple%20dark%20background%20with%20stars&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    rating: 4.8,
    views: 2100000,
    chapters: 210,
    status: 'ongoing',
    tags: ['末世', '小说', '星座'],
    updateTime: '2026-08-04',
    featured: true,
    hotRank: 3,
  },
  {
    id: 5,
    title: '乖乖女的恋爱指南',
    slug: 'good-girl-love-guide',
    category: 'school',
    author: '李多惠',
    description: '从小到大都是模范生的金多妍，在进入大学后决定改变自己。她制定了一份详细的恋爱指南，目标是谈一场完美的校园恋爱。然而计划总是赶不上变化，意外的邂逅让一切脱离了掌控。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20school%20romance%20Korean%20manhwa%20cover%20featuring%20a%20cute%20girl%20in%20school%20uniform%20with%20cherry%20blossoms%20falling%2C%20bright%20spring%20atmosphere%2C%20clean%20simple%20pastel%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    rating: 4.6,
    views: 670000,
    chapters: 56,
    status: 'ongoing',
    tags: ['大学', '恋爱', '成长'],
    updateTime: '2026-08-03',
    featured: false,
    hotRank: 8,
  },
  {
    id: 6,
    title: '狂王',
    slug: 'the-frenzy-king',
    category: 'action',
    author: '金圭森',
    description: '在强者为尊的世界里，一位被称为狂王的战士踏上了征服之路。无敌的力量、热血的战斗、兄弟的情谊，这是一部让人热血沸腾的史诗级韩漫。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fierce%20action%20Korean%20manhwa%20cover%20featuring%20a%20muscular%20warrior%20with%20red%20hair%20wielding%20a%20massive%20sword%2C%20intense%20battle%20atmosphere%2C%20fire%20and%20embers%2C%20clean%20simple%20dark%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    rating: 4.5,
    views: 980000,
    chapters: 142,
    status: 'ongoing',
    tags: ['战斗', '王者', '史诗'],
    updateTime: '2026-08-02',
    featured: true,
    hotRank: 4,
  },
  {
    id: 7,
    title: '表情包少女',
    slug: 'emoji-girl',
    category: 'comedy',
    author: '朴笑恩',
    description: '一个能用表情包和别人交流的奇怪少女，和她那群同样不正常的同学们，在高中里发生的各种爆笑日常。每一话都让你笑到停不下来，是缓解压力的最佳选择。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20Korean%20manhwa%20cover%20featuring%20a%20girl%20with%20exaggerated%20facial%20expressions%20and%20floating%20emoji%20stickers%20around%20her%2C%20bright%20and%20colorful%2C%20playful%20atmosphere%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    rating: 4.8,
    views: 1560000,
    chapters: 98,
    status: 'ongoing',
    tags: ['校园', '搞笑', '日常'],
    updateTime: '2026-08-04',
    featured: false,
    hotRank: 6,
  },
  {
    id: 8,
    title: '深渊之花',
    slug: 'abyss-flower',
    category: 'thriller',
    author: '暗夜',
    description: '在一座看似平静的小镇上，连续发生了多起离奇失踪案件。警察韩在民调查过程中，逐渐发现这些案件背后隐藏着一个惊人的秘密，而真相就在那朵深渊之花之中。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20thriller%20Korean%20manhwa%20cover%20featuring%20a%20red%20flower%20blooming%20in%20darkness%20with%20a%20shadowy%20figure%20behind%2C%20eerie%20atmosphere%2C%20fog%2C%20clean%20simple%20dark%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    rating: 4.7,
    views: 720000,
    chapters: 67,
    status: 'ongoing',
    tags: ['悬疑', '推理', '暗黑'],
    updateTime: '2026-08-01',
    featured: false,
    hotRank: 7,
  },
  {
    id: 9,
    title: '甜蜜的谎言',
    slug: 'sweet-lies',
    category: 'drama',
    author: '尹素熙',
    description: '为了守护家人的幸福，林秀雅不得已嫁给了一个陌生男人。本以为是一场交易婚姻，却在日复一日的相处中，发现了对方藏在冷漠外表下的真心。一个关于谎言与真爱的故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20romance%20Korean%20manhwa%20cover%20featuring%20a%20woman%20in%20a%20wedding%20dress%20with%20tears%20in%20her%20eyes%2C%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20clean%20simple%20background%20with%20soft%20warm%20tones&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 4.6,
    views: 550000,
    chapters: 78,
    status: 'completed',
    tags: ['契约婚姻', '虐恋', '治愈'],
    updateTime: '2026-07-28',
    featured: false,
    hotRank: 9,
  },
  {
    id: 10,
    title: '星之间',
    slug: 'between-stars',
    category: 'bl',
    author: '星河',
    description: '宇宙飞船驾驶员尹星和机械师韩宇宙，在执行一次星际任务时遭遇意外，被迫在一个荒芜的星球上共同生存。在无尽的星空之下，两颗孤独的心渐渐靠近。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20sci-fi%20romance%20Korean%20manhwa%20cover%20featuring%20two%20men%20standing%20under%20a%20starry%20night%20sky%20on%20an%20alien%20planet%2C%20purple%20and%20blue%20galaxy%20colors%2C%20romantic%20atmosphere%2C%20clean%20simple%20background%20with%20stars&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    rating: 4.8,
    views: 830000,
    chapters: 45,
    status: 'ongoing',
    tags: ['科幻', '星际', '治愈'],
    updateTime: '2026-08-04',
    featured: false,
    hotRank: 10,
  },
  {
    id: 11,
    title: '废妃的重生',
    slug: 'rebirth-of-abandoned-empress',
    category: 'fantasy',
    author: '金智恩',
    description: '被诬陷谋反而遭废黜的皇后艾丽莎，在临死前获得了一次重生的机会。带着前世的记忆回到过去，她发誓这一次绝不会再做任人宰割的棋子，她要让所有背叛她的人付出代价。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20historical%20Korean%20manhwa%20cover%20featuring%20an%20empress%20in%20magnificent%20golden%20royal%20robes%20with%20a%20determined%20expression%2C%20palace%20background%2C%20regal%20atmosphere%2C%20clean%20simple%20warm%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    rating: 4.7,
    views: 1100000,
    chapters: 93,
    status: 'ongoing',
    tags: ['重生', '复仇', '宫斗'],
    updateTime: '2026-08-03',
    featured: false,
    hotRank: 11,
  },
  {
    id: 12,
    title: '武道霸主',
    slug: 'martial-overlord',
    category: 'action',
    author: '剑心',
    description: '少年李青云出身平凡，却怀揣着成为武道至尊的梦想。凭借一本意外获得的神秘秘籍，他踏上了逆天改命的修炼之路。在这个强者为尊的世界里，他将用拳头打出一片属于自己的天地。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20manhwa%20cover%20featuring%20a%20young%20warrior%20in%20traditional%20martial%20arts%20robe%20with%20fists%20surrounded%20by%20energy%2C%20dynamic%20pose%2C%20powerful%20atmosphere%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    rating: 4.4,
    views: 760000,
    chapters: 134,
    status: 'ongoing',
    tags: ['武侠', '修炼', '逆袭'],
    updateTime: '2026-08-04',
    featured: false,
    hotRank: 12,
  },
];

export const faqs = [
  {
    question: '无遮韩国免费漫画大全是什么意思？',
    answer: '无遮韩国免费漫画大全是指我们网站提供的完整韩漫资源库，所有漫画都可以免费在线阅读，无需付费或订阅。我们致力于为韩漫爱好者打造一个内容丰富、更新及时、访问稳定的免费韩漫阅读平台。',
  },
  {
    question: '韩漫漫画网站是否需要注册才能阅读？',
    answer: '不需要！我们的韩漫漫画网站完全开放，所有用户都可以直接免费在线阅读韩漫，无需注册账号。我们相信好的内容应该让所有人免费获取，这也是我们创立这个网站的初衷。',
  },
  {
    question: '网站上的韩漫更新频率是怎样的？',
    answer: '我们每天都会更新最新的韩漫内容，热门连载漫画通常会在原版更新后24小时内同步上线。您可以收藏喜欢的漫画，第一时间获取更新通知，确保不错过任何精彩内容。',
  },
  {
    question: '如何找到我想看的韩漫？',
    answer: '您可以通过首页的分类导航按题材浏览，也可以使用搜索功能输入漫画名称查找。我们还提供了热门排行榜，帮助您发现当下最受欢迎的韩漫作品。分类涵盖恋爱、奇幻、热血、搞笑、悬疑等多种类型。',
  },
  {
    question: '网站在手机上能正常阅读吗？',
    answer: '当然可以！我们的韩漫漫画网站采用了响应式设计，完美适配手机、平板和电脑等各种设备。无论您在哪里，都能享受流畅舒适的免费在线阅读韩漫体验。',
  },
  {
    question: '网站访问稳定性如何？',
    answer: '我们使用了高性能服务器和CDN加速技术，确保网站访问高速稳定。即使是在阅读高峰时段，也能保证流畅的免费在线阅读体验。网站稳定性是我们最重视的用户体验之一。',
  },
];

export const aboutInfo = {
  brandName: '无遮韩国免费漫画大全',
  tagline: '免费在线阅读韩漫的首选平台',
  introduction: '无遮韩国免费漫画大全成立于2020年，是国内领先的韩漫漫画网站。我们专注于为用户提供最全面、最新、最优质的韩国漫画资源，让每一位韩漫爱好者都能在这里享受免费在线阅读韩漫的乐趣。经过多年的发展，我们已经成为国内最受欢迎的韩漫阅读平台之一，日活跃用户超过百万。',
  mission: '我们的使命是打破语言和地域的壁垒，让全球中文读者都能免费享受到高质量的韩国漫画。我们相信，好的故事值得被更多人看到。',
  vision: '成为中文世界最大的韩漫免费阅读平台，构建一个充满活力的韩漫爱好者社区。',
  values: [
    { title: '免费开放', description: '所有漫画资源完全免费，无需任何付费即可畅享阅读。我们坚持内容的开放与共享。' },
    { title: '内容为王', description: '严格筛选优质韩漫内容，确保每一部作品都具有高水准的故事和画风。' },
    { title: '用户体验', description: '不断优化网站性能和阅读体验，让用户享受流畅、舒适的阅读过程。' },
    { title: '尊重版权', description: '与韩国多家漫画平台和作者保持良好合作关系，推动正版韩漫的传播。' },
  ],
  stats: [
    { value: '5000+', label: '漫画资源' },
    { value: '100万+', label: '日活跃用户' },
    { value: '99.9%', label: '网站稳定性' },
    { value: '24h', label: '更新速度' },
  ],
  contact: {
    email: 'contact@manhwa-free.com',
    wechat: 'manhwa_official',
    qq: '1234567890',
    address: '北京市朝阳区望京SOHO T1栋 15层',
    phone: '400-888-6666',
  },
};

export const articles = [
  {
    id: 101,
    title: '2026年最值得追的十大韩漫推荐',
    slug: 'top-10-manhwa-2026',
    excerpt: '新的一年又到了，韩漫市场也涌现出了大量优秀的作品。我们为大家精心挑选了十部2026年最值得追的韩漫，每一部都堪称精品。',
    content: `<p>2026年的韩漫市场可谓是百花齐放，各种题材的优秀作品层出不穷。无论你是喜欢热血的战斗漫画，还是偏爱甜蜜的恋爱故事，今年都不会让你失望。以下是我们的编辑团队精心挑选的十大必追韩漫，排名不分先后。</p><h3>1. 我独自升级</h3><p>这部作品已经不需要过多介绍。作为近年来最火爆的韩漫之一，《我独自升级》凭借其出色的世界观设定和令人热血沸腾的战斗场面，赢得了全球读者的喜爱。2026年虽然主线已经完结，但外传和后日谈依然精彩。</p><h3>2. 某天成为公主</h3><p>穿越题材的巅峰之作，精致的画风和感人的剧情让无数读者泪目。如果你喜欢温馨治愈又不乏深度的故事，这部绝对不容错过。</p><h3>3. 全知读者视角</h3><p>当小说变成现实，唯一知道结局的人将如何改变世界？这部作品脑洞大开，剧情环环相扣，是近年来少有的高智商韩漫。</p><h3>4. 乖乖女的恋爱指南</h3><p>如果你想找一部轻松甜蜜的校园恋爱漫画，这部绝对是你的菜。清新的画风加上真实动人的青春故事，让人忍不住一口气追完。</p><h3>5. 狂王</h3><p>战斗场面的天花板级别作品，每一场战斗都让人血脉偾张。如果你钟爱硬核战斗漫画，狂王绝对不会让你失望。</p><h3>6. 废妃的重生</h3><p>重生复仇题材的经典之作。女主角从前世的软弱皇后蜕变为今生的铁腕女强人，每一步棋都让人拍案叫绝。</p><h3>7. 深渊之花</h3><p>悬疑推理类韩漫的佼佼者。每一条线索都埋藏得恰到好处，让读者在紧张刺激的剧情中享受推理的乐趣。</p><h3>8. 表情包少女</h3><p>笑点密集、节奏飞快，是缓解压力的最佳选择。每一话都有让人捧腹的名场面，追更的过程就是一场欢乐之旅。</p><h3>9. 武道霸主</h3><p>传统武侠与现代漫画的完美结合。主角从平凡到巅峰的成长历程，既热血又励志。</p><h3>10. 甜蜜的谎言</h3><p>一部让人又哭又笑的虐恋神作。它告诉我们，有时候最甜蜜的爱情，往往始于最美丽的谎言。</p>`,
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20colorful%20vibrant%20collage%20of%20Korean%20manhwa%20art%20styles%20featuring%20various%20characters%20from%20different%20genres%2C%20dynamic%20composition%2C%20energetic%20atmosphere%2C%20clean%20simple%20background&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '编辑团队',
    publishDate: '2026-08-01',
    views: 15680,
  },
  {
    id: 102,
    title: '韩漫入门指南：从零开始了解韩国漫画',
    slug: 'manhwa-beginners-guide',
    excerpt: '如果你是第一次接触韩漫，可能会对它的特点和阅读方式感到陌生。这篇入门指南将带你全面了解韩国漫画的魅力所在。',
    content: `<p>韩国漫画，简称韩漫（Manhwa），近年来在全球范围内迅速崛起，成为漫画世界中不可忽视的一股力量。如果你还没有接触过韩漫，或者对它不太了解，这篇入门指南绝对能帮你打开新世界的大门。</p><h3>韩漫与日漫的区别</h3><p>很多人会问，韩漫和日漫有什么区别？首先，韩漫的阅读方式是纵向滚动的，完美适配手机屏幕。其次，韩漫通常是全彩的，画面更加精美。再者，韩漫的叙事节奏通常更快，更注重剧情的紧凑性和视觉冲击力。</p><h3>韩漫的主要题材</h3><p>韩漫的题材非常丰富，几乎涵盖了所有你能想到的类型。恋爱、奇幻、热血、搞笑、悬疑、校园、耽美……无论你喜欢什么样的故事，都能在韩漫中找到心仪的作品。特别是恋爱和奇幻题材，是韩漫最强的两大支柱。</p><h3>为什么韩漫这么受欢迎？</h3><p>首先，全彩的画面让阅读体验更加沉浸。其次，纵向滚动的阅读方式非常适合手机用户。再者，韩漫的剧情通常更加直接，不会拖沓，能够快速抓住读者的注意力。最后，韩漫的更新速度非常快，热门作品通常每周都会更新。</p><h3>在哪里可以免费阅读韩漫？</h3><p>无遮韩国免费漫画大全就是您的最佳选择！我们提供了海量的韩漫资源，全部免费在线阅读。网站稳定性高，更新速度快，是韩漫爱好者的天堂。</p><h3>推荐给新手的入门韩漫</h3><p>如果你是韩漫新手，我们推荐从《某天成为公主》或《我独自升级》开始。这两部作品分别代表了韩漫在恋爱奇幻和热血战斗两个方向上的最高水准，非常适合作为入门的第一部韩漫。</p>`,
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20illustration%20showing%20a%20smartphone%20displaying%20colorful%20Korean%20webtoon%20panels%20with%20vertical%20scrolling%20layout%2C%20modern%20and%20clean%20design%2C%20warm%20lighting&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '编辑团队',
    publishDate: '2026-07-28',
    views: 23450,
  },
  {
    id: 103,
    title: '我独自升级完结：一部改变韩漫格局的作品',
    slug: 'solo-leveling-legacy',
    excerpt: '《我独自升级》正式完结，这部现象级韩漫不仅收获了全球数亿读者，更彻底改变了人们对韩国漫画的认知。',
    content: `<p>2026年，《我独自升级》正式画上了句号。这部由Chugong创作的现象级韩漫，从连载开始就吸引了全球无数读者的目光，成为了韩漫走向世界的标志性作品。</p><h3>从网文到漫画的华丽转身</h3><p>《我独自升级》最初是一部网络小说，在韩国获得了极高的人气后被改编为漫画。漫画版本在保留原著精髓的基础上，通过出色的画风和对战斗场面的精彩演绎，让这个故事焕发出了全新的生命力。</p><h3>成振宇：从最弱到最强的成长之路</h3><p>主角成振宇被称为"人类最弱兵器"，在觉醒者中实力垫底。但在一次濒死体验后，他获得了神秘的"系统"，从此开启了无限升级的逆袭之路。这个从最弱到最强的成长故事，深深打动了每一位读者。</p><h3>影之军队与史诗级战斗</h3><p>成振宇最标志性的能力就是召唤影之军队。从最初的几个影兵到后来的千军万马，每一次战斗场面的升级都让读者热血沸腾。特别是与蚁王、君主等强力敌人的对决，堪称韩漫战斗场面的巅峰之作。</p><h3>为什么《我独自升级》如此成功？</h3><p>首先，它满足了读者对"逆袭爽文"的需求。其次，出色的画风让每一场战斗都充满视觉冲击力。最后，世界观设定虽然不算新颖，但执行得非常到位，每个细节都经得起推敲。</p><h3>对韩漫产业的影响</h3><p>《我独自升级》的成功向世界证明了韩漫的商业价值和文化影响力。它带动了更多韩国漫画走向国际市场，也让更多创作者看到了韩漫的无限可能。可以说，它是韩漫发展史上的一个里程碑。</p>`,
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20dark%20fantasy%20scene%20featuring%20a%20shadow%20army%20behind%20a%20hooded%20figure%20with%20glowing%20eyes%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20clean%20simple%20background&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '资深编辑 金浩宇',
    publishDate: '2026-07-25',
    views: 45210,
  },
  {
    id: 104,
    title: '恋爱韩漫推荐：甜到让你心花怒放的十部佳作',
    slug: 'best-romance-manhwa',
    excerpt: '恋爱题材是韩漫最强的领域之一。我们精选了十部甜到爆炸的恋爱韩漫，每一部都能让你感受到心动的感觉。',
    content: `<p>韩国漫画在恋爱题材上的表现力堪称一绝。精致的画风、细腻的情感描写、恰到好处的心动时刻——这些都是韩漫恋爱作品的独特魅力。如果你正在寻找一部能让你少女心爆棚的恋爱韩漫，这份榜单就是为你准备的。</p><h3>1. 某天成为公主</h3><p>虽然是奇幻背景，但克劳德和阿塔娜西亚之间的父女情、以及后续的恋爱情节，都甜得让人心醉。Spoon老师的画风更是加分项，每个角色都美得让人窒息。</p><h3>2. 她的私生活</h3><p>职场恋爱题材的代表作。成德美和莱恩·金之间的化学反应简直爆表，每一话都让人嘴角上扬。特别是那些职场中不经意的甜蜜互动，真实的让人心动。</p><h3>3. 乖乖女的恋爱指南</h3><p>校园恋爱中的清新之作。女主角从"乖乖女"到勇敢追爱的成长过程，既真实又温暖。如果你怀念青春的感觉，这部绝对不能错过。</p><h3>4. 甜蜜的谎言</h3><p>先婚后爱题材的佳作。从互相试探到真心相爱的过程，虽然虐心但也格外甜蜜。这部剧告诉我们，最好的爱情往往在最意想不到的地方等着你。</p><h3>5. 秘密恋爱</h3><p>办公室地下恋情的故事，充满了偷摸约会的刺激感和甜蜜。两位主角之间的化学反应让人欲罢不能，每一话都想追着看。</p><h3>6. 我的ID是江南美人</h3><p>关于容貌焦虑和自我认同的深刻故事，同时也是一部甜到爆的恋爱漫画。都炅锡和姜美来的爱情，让人相信真正的爱是超越外表的。</p><h3>7. 女神降临</h3><p>化妆改变人生的题材，恋爱线甜蜜又搞笑。修豪、书俊两个男神各有魅力，让人纠结到底站哪对CP。</p><h3>8. 偶然发现的一天</h3><p>打破第四面墙的奇幻恋爱故事。女主角发现自己只是漫画中的配角后，与一个"无名配角"展开了一段独特的恋情，设定新颖又甜蜜。</p><h3>9. 金秘书为何那样</h3><p>霸道总裁与秘书的经典搭配，但韩漫的版本更加细腻和真实。副会长的傲娇和自恋让人又爱又恨。</p><h3>10. 喜欢的话请响铃</h3><p>科技感十足的恋爱设定——一个能探测周围喜欢你的人的APP。两个男主角各有千秋，恋爱线和科技设定的结合让故事格外有趣。</p>`,
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20illustration%20with%20cherry%20blossoms%20and%20soft%20pink%20tones%20featuring%20two%20figures%20holding%20hands%20in%20a%20dreamy%20atmosphere%2C%20watercolor%20style%2C%20clean%20simple%20background&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '编辑 李秀雅',
    publishDate: '2026-07-20',
    views: 38900,
  },
];

export const latestUpdates = [
  { comicId: 1, chapter: '第125话', title: '幸福的结局', date: '2026-08-03' },
  { comicId: 2, chapter: '第179话', title: '终章·新的开始', date: '2026-08-04' },
  { comicId: 3, chapter: '第87话', title: '意外的告白', date: '2026-08-04' },
  { comicId: 4, chapter: '第210话', title: '最终幕的序曲', date: '2026-08-04' },
  { comicId: 7, chapter: '第98话', title: '表情包大战', date: '2026-08-04' },
  { comicId: 12, chapter: '第134话', title: '突破瓶颈', date: '2026-08-04' },
  { comicId: 5, chapter: '第56话', title: '樱花下的约定', date: '2026-08-03' },
  { comicId: 11, chapter: '第93话', title: '复仇的序曲', date: '2026-08-03' },
];